/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MoveResult } from './moveResult';

export type GenericApiResponseMoveResultData = MoveResult | null;
